import { Box, Grid } from "@mui/material"
import { PoweredBy } from "components/PoweredBy/PoweredBy"
import Footer from "components/Unit/Footer"
import { MapModalButton } from "components/Unit/FullscreenMap"
import Mapbox from "components/Unit/Mapbox"
import { useAtom } from "jotai"
import { map_State } from "state/store.global"
import SignUpForm from "./SignUpForm"
import { useEffect, useState } from "react"

export const DesktopFooter = () => {
    const [open] = useAtom(map_State);
 const [hydrated, setHydrated] = useState(false);

  // ✅ Ensure Mapbox only mounts after client-side hydration
  useEffect(() => {
    setHydrated(true);
  }, []);

    return <Grid
    container
    sx={(theme)=> ({
      // background    : `linear-gradient(180deg, ${f_clr.primaryColor} 0%, ${f_clr.primaryColor}66 100%)`,
      background: "#F0EEEF",
      borderRadius: " 16px 16px 0 0 ",
      display       : 'flex',
      justifyContent: 'center',
        // [theme.breakpoints.down('1314')]:{
        //   flexDirection: 'column-reverse'
        // },
    })
    }
  >
    <Box sx={(theme)=> ({ 
      
      display                         : 'flex',
      width                           : "100%",
      flexWrap                        : "wrap",
      justifyContent                  : 'center',
      [theme.breakpoints.down('1314')]: {
        alignItems   : 'center',
        flexDirection: 'column-reverse'
      },
      })}>
    <Grid item sx={(theme)=> ({ 
        [theme.breakpoints.up('1576')]:{
        // display: "flex", 
        maxWidth: '773px',
          width   : "39%"
      },
      [theme.breakpoints.down('1576')]:{
        maxWidth: "765px",
        width   : "39%"
      },
      [theme.breakpoints.down('1314')]:{
        maxWidth: "773px",
        width   : "68%"
      },
        })}>
      <SignUpForm
      // unit = {unit}
       />
      <Box        sx   = { (theme)=> ({
          display: "none",
      [theme.breakpoints.down('1314')]: {
        display: "block"
      },
    })}>
        {/* <Footer /> */}
      </Box>
    </Grid>
    <Grid item sx={ (theme)=> ({ 
      color                           : "secondary.contrastText", minWidth: '801px', pr: "45px",
      [theme.breakpoints.down('1314')]: {
        pr: "0"
      },
    })}>
      {/* mapbox spcae */}
      <Box
        sx={{
          mt: "40px"
        }}
      >
         {hydrated && !open && <Mapbox />}
        {/* <MapboxNew /> */}
    
        <MapModalButton />
        
      </Box>
      <Box        sx   = { (theme)=> ({
          // display: "none",
      [theme.breakpoints.up('1314')]: {
        // display: "block"
      },
    })}>
        <Footer />
      </Box>
    </Grid>
    </Box>

    <PoweredBy clr = {"#000"} />
  </Grid>
}